angular.module('pe4h').controller('RecoverPassword', function ($scope, $rootScope, $state, $http, configuration, AuthService, $stateParams) {

  $scope.init = function(){
    $http({
      url: configuration.webApi.auth.validate_reset_password,
      method: "POST",
      data: {
        "Token": $stateParams.token,
      },
    }).success(function (res, status, headers, config) {
    }).error(function (error, status, headers, config) {
      console.log("Alert error: Invalid token");
      $scope.alertErrorFromServer(error, null, "Sorry", true);
    });
  }

  $scope.recoverPassword = function () {
    if ($scope.newPassword != $scope.newPasswordConfirmation) {
      $scope.alertError("Error", "The passwords do not match");
    } else {
      $http({
        url: configuration.webApi.auth.confirm_reset_password,
        method: "POST",
        data: {
          "Token": $stateParams.token,
          "Password": $scope.newPassword
        },
      }).success(function (res, status, headers, config) {
        $scope.alertError("Success", "Password updated!", function () {
          $state.go("login");
        });
      }).error(function (error, status, headers, config) {
        $scope.alertErrorFromServer(error, null, "Sorry", true);
      });
    }
  };

  $scope.init();
});
